import type { SavedReport } from '@/data/reporting/models/SavedReport';
import type { WiwState } from '@/store';

import type { Map } from 'immutable';

export const getSavedReports = (state: WiwState): Map<SavedReport['id'], SavedReport> =>
  state.data.reporting.savedReports.items;
